/* global $ */

import 'slick-carousel';

const $sliders = $('.js-slider');

function getIcon(name) {
  return `
    <svg class="icon icon-${name}" aria-hidden="true">
      <use xlink:href="#icon-${name}"></use>
    </svg>
  `;
}

function getButton(text, className, icon) {
  return `
    <button type="button" class="${className}">
      <span class="sr-only">${text}</span>
      ${getIcon(icon)}
    </button>
  `;
}

const generalSlider = {
  initialize() {
    if ($sliders.length) {
      this.create();
    }
  },

  create() {
    $sliders.each((i, slider) => {
      const $slider = $(slider);
      const options = $slider.data();

      const config = {
        rows: 0,
        dots: true,
        prevArrow: getButton('Vorige', 'btn--reset slider__arrow slick-prev', 'chevron-left'),
        nextArrow: getButton('Volgende', 'btn--reset slider__arrow slick-next', 'chevron-right'),
      };

      if ($slider.hasClass('mobile-only-slider')) {
        config.responsive = [
          {
            breakpoint: 9999,
            settings: 'unslick',
          },
          {
            breakpoint: 992,
            settings: {
              rows: 0,
              dots: true,
              prevArrow: config.prevArrow,
              nextArrow: config.nextArrow,
              centerMode: true,
              centerPadding: '2rem',
              infinite: false,
            },
          },
        ];
      }

      if (typeof options !== 'undefined') {
        const optionKeys = Object.keys(options);

        optionKeys.forEach((option) => {
          const regex = new RegExp('^slider', 'g');

          if (regex.test(option)) {
            let transformedOption = option.replace('slider', '');
            transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

            config[transformedOption] = options[option];
          }
        });
      }

      $slider.slick(config);

      if ($slider.data('caption-output')) {
        this.handleCaptions($slider);
      }
    });
  },

  /**
   * @param {object} $slider
   * @return {void}
   */
  handleCaptions($slider) {
    const $output = $('body').find(`#${$slider.data('caption-output')}`);

    $slider.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
      this.handleCaption(slick, nextSlide, $output);
    });

    this.handleCaption($slider.slick('getSlick'), 0, $output);
  },

  handleCaption(slick, slide, $output) {
    const nextSlideElement = slick.$slides[slide];
    const $image = $(nextSlideElement).find('img');
    const caption = $image.length ? $image.data('caption') : '';

    $output.text(caption);
  },
};

export default generalSlider;
